const NODE_TYPES = {
  // Просто город, который проезжаем мимо не заезжая в него
  passing: 0,
  
  // Начало маршрута
  start: 1,
  
  // Конец маршрута
  finish: 2,

  // Точка загрузки
  load: 4,

  // Точка разгрузки
  unload: 8,

  // Промежуточная точка
  passthrough: 16,

  // Таможня
  custom: 32
};
Object.freeze(NODE_TYPES);

export default NODE_TYPES;